// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner_banner__IU43Q","bannerContent":"Banner_bannerContent___mIbe"};